import { render, staticRenderFns } from "./WordBook.vue?vue&type=template&id=5667427e&scoped=true"
import script from "./WordBook.vue?vue&type=script&lang=js"
export * from "./WordBook.vue?vue&type=script&lang=js"
import style0 from "./WordBook.vue?vue&type=style&index=0&id=5667427e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667427e",
  null
  
)

export default component.exports